import {
  prefetchCustomerCompanyRetrieveQuery,
  prefetchCustomerPartialBusinessAddressRetrieveQuery,
  useCustomerBusinessAddressRetrieve,
  useCustomerPartialBusinessAddressRetrieve,
} from "@boundless/bl-api-client/customer/services"
import { createFileRoute, redirect } from "@tanstack/react-router"

import { BusinessAddressForm } from "@/components/business-details/BusinessAddressForm"
import { PendingComponent } from "@/components/error/PendingComponent"

export const Route = createFileRoute("/_dashboard/company/address")({
  component: RouteComponent,
  beforeLoad: ({ context: { store, hasPermissions } }) => {
    if (!hasPermissions(["customer.view_businessaddress"])) {
      throw redirect({ to: "/" })
    }
    const companyUuid = store.getState().activeCompanyUuid
    if (!companyUuid) {
      throw redirect({ to: "/company/details" })
    }
    return { companyUuid }
  },
  loader: async ({ context: { queryClient, companyUuid } }) => {
    prefetchCustomerCompanyRetrieveQuery(queryClient, companyUuid)
    prefetchCustomerPartialBusinessAddressRetrieveQuery(
      queryClient,
      companyUuid,
    )
  },
})

export function RouteComponent() {
  const { companyUuid } = Route.useRouteContext()

  const { data: businessAddress, isLoading: isAddressLoading } =
    useCustomerBusinessAddressRetrieve(companyUuid, {
      query: { refetchOnWindowFocus: false },
    })

  const { data: partialBusinessAddress, isLoading: isPartialLoading } =
    useCustomerPartialBusinessAddressRetrieve(companyUuid, {
      query: { refetchOnWindowFocus: false },
    })

  if (isAddressLoading || isPartialLoading) {
    return <PendingComponent />
  }

  return (
    <div className="@container">
      <div className="grid grid-cols-1 lg:grid-cols-3">
        <div className="lg:col-span-2">
          <BusinessAddressForm
            companyUuid={companyUuid}
            businessAddress={businessAddress}
            partialBusinessAddress={partialBusinessAddress}
          />
        </div>
      </div>
    </div>
  )
}
